import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SecureDataLandscape from './SecureDataLandscape';
import EncryptionSources from './EncryptionSources';
import MaskingSources from './MaskingSources';
import EncryptionInventoryPage from './EncryptionSources/InventoryPage';
import MaskingInventoryPage from './MaskingSources/InventoryPage';
import MaskingSummary from './MaskingSummary';
import EncryptionSummary from './EncryptionSummary';
import MaskingResults, { EncryptResults, DecryptResults } from './MaskingResults';
import JobGroups from './JobGroups';
import AddStepPage from './JobGroups/AddStepPage';

function Secure() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <SecureDataLandscape />
      </Route>
      <Route exact path={`${path}/groups`}>
        <JobGroups />
      </Route>
      <Route exact path={`${path}/groups/:groupId/step`}>
        <AddStepPage />
      </Route>
      <Route exact path={`${path}/encrypt`}>
        <EncryptionSources />
      </Route>
      <Route exact path={`${path}/encrypt/inventory/:id`}>
        <EncryptionInventoryPage />
      </Route>
      <Route exact path={`${path}/mask`}>
        <MaskingSources />
      </Route>
      <Route exact path={`${path}/mask/inventory/:id`}>
        <MaskingInventoryPage />
      </Route>
      <Route exact path={`${path}/mask/results/:jobId`}>
        <MaskingResults />
      </Route>
      <Route exact path={`${path}/encrypt/results/:jobId`}>
        <EncryptResults />
      </Route>
      <Route exact path={`${path}/decrypt/results/:jobId`}>
        <DecryptResults />
      </Route>
      <Route exact path={`${path}/masksummary/:id`}>
        <MaskingSummary />
      </Route>
      <Route exact path={`${path}/encryptsummary/:id`}>
        <EncryptionSummary />
      </Route>
    </Switch>
  );
}

export default Secure;